import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  LGA_FEATURE_KEY,
  LgaState,
  LgaPartialState,
  lgaAdapter
} from './lga.reducer';

// Lookup the 'Lga' feature state managed by NgRx
export const getLgaState = createFeatureSelector<
  LgaPartialState,
  LgaState
>(LGA_FEATURE_KEY);

const { selectAll, selectEntities } = lgaAdapter.getSelectors();

export const getLgaLoaded = createSelector(
  getLgaState,
  (state: LgaState) => state.loaded
);

export const getLgaError = createSelector(
  getLgaState,
  (state: LgaState) =>  state.error
);

export const loadingLga = createSelector(
  getLgaState,
  (state: LgaState) =>  state.loaded
);

export const getAllLga = createSelector(
  getLgaState,
  (state: LgaState) => selectAll(state)
);

export const getLgaEntities = createSelector(
  getLgaState,
  (state: LgaState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getLgaState,
  (state: LgaState) => state.selectedLgaId
);

export const getSelected = createSelector(
  getLgaEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);
